export default __webpack_public_path__ + "static/genre_05-86bba4702939f5d074b3551ff9bd1d3d.png";